import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React, { useCallback, useEffect, useLayoutEffect, useRef, useState } from 'react';
import StackView from '../StackView';

function DrawerContents(_ref) {
  var shouldClose = _ref.shouldClose,
      onClose = _ref.onClose,
      restProps = _objectWithoutPropertiesLoose(_ref, ["shouldClose", "onClose"]);

  var ref = useRef(null);

  var _useState = useState(false),
      show = _useState[0],
      setShow = _useState[1];

  useEffect(function () {
    var node = ref.current;
    var firstTransition = true;

    function handleTransitionEnd(event) {
      if (event.target === node && event.propertyName === 'transform') {
        if (firstTransition) {
          firstTransition = false;
        } else {
          onClose();
        }
      }
    }

    setShow(true);
    node.addEventListener('transitionend', handleTransitionEnd);
    return function () {
      node.removeEventListener('transitionend', handleTransitionEnd);
    };
  }, []);
  useEffect(function () {
    if (shouldClose) {
      setShow(false);
    }
  }, [shouldClose]);
  return /*#__PURE__*/React.createElement(StackView, _extends({
    innerRef: ref,
    width: 52,
    height: "100%",
    x: (show ? 0 : 100) + "%",
    position: "absolute",
    bottom: 0,
    right: 0,
    zIndex: 999,
    boxShadow: "-6px 0px 6px -4px rgba(150,150,150,0.25)",
    backgroundColor: "surfaceTertiary",
    transition: "transform 240ms ease-out"
  }, restProps));
}

function Drawer(props) {
  var open = props.open,
      restProps = _objectWithoutPropertiesLoose(props, ["open"]);

  var _useState2 = useState(null),
      localOpen = _useState2[0],
      setLocalOpen = _useState2[1];

  var _useState3 = useState(null),
      shouldClose = _useState3[0],
      setShouldClose = _useState3[1];

  var handleClose = useCallback(function () {
    setLocalOpen(false);
    setShouldClose(true);
  }, []);
  useLayoutEffect(function () {
    if (open) {
      setLocalOpen(true);
      setShouldClose(false);
    } else if (localOpen !== null) {
      setShouldClose(true);
    }
  }, [open]);
  return localOpen && /*#__PURE__*/React.createElement(DrawerContents, _extends({
    shouldClose: shouldClose,
    onClose: handleClose
  }, restProps));
}

export default Drawer;